<template>
	<el-dialog title="电子合同" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px"
		@close="dialogClose">
		<div class="cont" style="height:450px">
			<div style="width:60%;margin:0 auto;background-color:rgb(255, 255, 255);padding: 10px;">
				<div>
					<div class="title0">合同编号:</div>
					<div class="head1">售后服务承揽协议</div>
					<div class="head2">纽恩泰（{{ 2024 }} 年度）</div>
					<div class="title1">甲 方：广东纽恩泰新能源科技股份有限公司</div>
					<div class="title1">乙 方：</div>
					<div class="title1">网点编码：</div>
					<div class="head3">签订日期:2024 年 01 月 15日</div>
				</div>
				<!-- 第二页------------------------------------ -->
				<div>
					<div class="title2">甲 方：广东纽恩泰新能源科技股份有限公司</div>
					<div class="title2">乙 方：</div>
					<div class="content1">甲乙双方本着相互信任、互惠互利原则， 甲方委托乙方负责发包片区售后服务工作，经甲、乙双方友好协商,达成如下协议并共同遵守:</div>
					<div class="title2">第一条：承包区域</div>
					<div class="content1">
						甲方委托乙方就————————————区域设备进行售后服务，甲方委托乙方负责————————————————————————————省——————————市————————————————————县——————————————————镇地区售后服务工作，负责区域包括：
						——————————————————————————————————————————————
					</div>

					<div class="content1">(请详细写清楚服务区域)。甲方根据客户需求向乙方派发售后维护订单，乙方收到甲方派发订单后应在
						本协议约定时间内或订单约定时间内前往设备维修点开展维护工作。乙方承担甲方售后服务的合作方式和
						内容如下：(在括号内打“√”表示选择对应项)。</div>
					<div class="bgM">
						<div>
							<span class="bg1">服务网点类别</span>
							<span class="bg2">第一服务网点() 第二服务网()</span>
						</div>

						<div>
							<span class="bg1">服务产品类别</span>
							<span class="bg2">纽恩泰家用() 纽恩泰商用工程()</span>
						</div>
						<div class="bg3">说明：维修单优先派发第一服务网点，如出现网点维修任务繁忙，无法达到服务时效要求时，启用第二服务网点。</div>
					</div>
					<div class="title2">第二条：维修费用及远程补助标准</div>
					<div class="content1">1、维修费用结算标准：</div>
					<div class="bgM">
						<div>
							<span class="bg5 bgC">基础维修费</span>
							<span class="bg4 bgC">满意奖励</span>
							<span class="bg4 bgC">非常满意奖励</span>
						</div>
						<div>
							<span class="bg5">详见《维修服务结算标准表》</span>
							<span class="bg4">结算标准的10%</span>
							<span class="bg4">结算标准的30%</span>
						</div>
						<div class="bg6">说明：
							<div>1、维修费用由基础费用，服务质量奖励两部分组成；</div>
							<div> 2、售前机(未销售的机器)维修信息必须由甲方经销商直接报至400售后服务热线，由甲方派单至各售后
								服务商。如乙方未不按此操作，甲方有权将不给予结算；</div>
						</div>
					</div>

					<div class="content1">2、远程补助：</div>
					<!-- <div>
						<span class="bg5 bgC">里程</span>
						<span class="bg4 bgC">结算标准</span>
						<span class="bg4 bgC">审批流程</span>
					</div>
					<div>
						<span class="bg5"> < 15公里 </span>
						<span class="bg4">无远程费用</span>
						<span class="bg4"> <span style="visibility: hidden;">1</span></span>
					</div>
					<div>
						<span class="bg5">15公里≤里程 < 50公里</span>
						<span></span>
						<span class="bg4">系统申报里程，经甲方审批通过后给予补助</span>
					</div>
					<div>
						<span class="bg5">50公里≤里程 < 100公里</span>
						<span>单程公里数*2元/公里</span>
						<span  class="bg4">系统申报里程，经甲方审批通过后给予补助</span>
					</div>	
					<div>
						<span class="bg5"> > 100公里</span>
						<span></span>
						<span  class="bg4">系统申报里程，经甲方审批通过后给予补助</span>
					</div> -->
					<div class="bgM">

						<table border="1">
							<thead>

								<tr>

									<th class="bgC2 bg5_2">里程</th>
									<th class="bgC2 bg4_2">结算标准</th>
									<th class="bgC2 bg4_2"> 审批流程</th>



								</tr>
							</thead>
							<tbody>
								<tr>

									<td class="bg5_2"> < 15公里</td>
									<td class="bg4_2">无远程费用</td>
									<td class="bg4_2"></td>
								</tr>
								<tr>

									<td class="bg5_2">15公里≤里程 < 50公里</td>
									<td  rowspan="3">单程公里数*2元/公里</td>
									<td>系统申报里程，经甲方审批通过后给予补助</td>
								</tr>
								<tr>
									<td class="bg5_2">50公里≤里程 < 100公里</td>
									<!-- <td>单程公里数*2元/公里</td> -->
									<td>系统申报里程，经甲方审批通过后给予补助</td>


								</tr>
								<tr>
									<td class="bg5_2"> > 100公里</td>
									<!-- <td>单程公里数*2元/公里</td> -->
									<td>系统申报里程，经甲方审批通过后给予补助</td>
								</tr>

							</tbody>
						</table>
					</div>
				</div>
				<!-- 第三页------------------------------------ -->


			</div>
		</div>

		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param'],
	mixins: [selectDialogMixins],
	created() {
		this.initSetting();
	},
	mounted() {
		this.initTableM1();
	},
	data() {
		var that = this;
		return {
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			formData: { usable: 1 },
			vxeOption: {}
		};
	},
	methods: {
	}
};
</script>
<style lang="scss" scoped>
::v-deep .dialog-style.list-dialog .el-dialog__body .cont {
	background: #bebebe;
}


.head1 {
	text-align: center;
	color: black;
	font-size: 30px;
	margin-top: 100px;
}

.head2 {
	text-align: center;
	color: black;
	font-size: 16px;
	margin: 10px 0 100px;
}

.head3 {
	text-align: center;
	color: black;
	font-size: 16px;
	margin: 100px 0 100px;
}

.title0 {
	color: black;
	font-size: 16px;
}

.title1 {
	margin-left: 10px;
	margin-bottom: 10px;
	color: black;
	font-size: 18px;
}

.title2 {
	margin-left: 10px;
	margin-bottom: 10px;
	margin-top: 10px;
	color: black;
	font-size: 15px;
}

.content1 {
	font-size: 13px;
	margin-left: 12px;
}

.bg1 {
	border: 1px solid #b5b5b5;
	display: inline-block;
	width: 150px;
	padding: 3px;
}

.bg2 {
	border: 1px solid #b5b5b5;
	display: inline-block;
	width: 350px;
	padding: 3px;
}

.bg3 {
	border: 1px solid #b5b5b5;
	display: inline-block;
	width: 500px;
	padding: 3px;
}

.bg4 {
	border: 1px solid #b5b5b5;
	display: inline-block;
	width: 150px;
	padding: 3px;
	height: 25px;
}
.bg4_2 {


	width: 150px;
	padding: 3px;

}

.bg5 {
	border: 1px solid #b5b5b5;
	display: inline-block;
	width: 200px;
	padding: 3px;
	height: 25px;

}
.bg5_2 {


	width: 200px;
	padding: 3px;


}

.bg6 {
	border: 1px solid #b5b5b5;
	display: inline-block;
	width: 500px;
	padding: 3px;


}

.bgM {
	margin: 10px
}

.bgC {
	text-align: center;
	background-color: #FDEADA;
}
.bgC2 {
	font-size: 14px;
    font-weight: 400;
	text-align: center;
	background-color: #FDEADA;
}
</style>